import { render } from "./BudgetMonitoring.vue?vue&type=template&id=5460bec6&scoped=true"
import script from "./BudgetMonitoring.vue?vue&type=script&lang=js"
export * from "./BudgetMonitoring.vue?vue&type=script&lang=js"

import "./BudgetMonitoring.vue?vue&type=style&index=0&id=5460bec6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5460bec6"]])

export default __exports__